import type { LodasPersonData } from '../../server/lodas/LodasPersonData.js';

export function generateChildData(satzNummer: string, persons: LodasPersonData[]) {
  const mappedLine: string[] = [];

  for (const person of persons) {
    if (!person.childInformation.length) continue;

    for (let i = 0; i < person.childInformation.length; i++) {
      const info = person.childInformation[i];
      if (!info) continue;
      mappedLine.push(
        `${satzNummer};"${person.personalNr}";"${person.lodasPersonalNr}";${info.kindNr};${info.kindGeburtsdatum};${info.kindNachname};${info.kindVorname};`,
      );
    }
  }

  return mappedLine.join('\r\n');
}
